import { BaseClient } from '../BaseClient';
import { CallWindowLimit, CallWindowLimitList } from '../compiled-protos/call_window_limit';
import { CallWindowLimitServiceClient } from '../compiled-protos/call_window_limit.client';
import { Empty } from '../compiled-protos/common';

class CallWindowLimitClient extends BaseClient {
  self: CallWindowLimitServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new CallWindowLimitServiceClient(this.transport);
  }

  public async Create(req: CallWindowLimit): Promise<CallWindowLimit | undefined> {
    let res = CallWindowLimit.create();
    try {
      res = await this.self.createCallWindowLimit(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Get(req: CallWindowLimit): Promise<CallWindowLimit | undefined> {
    let res = CallWindowLimit.create();
    try {
      res = await this.self.getCallWindowLimit(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGet(req: CallWindowLimit): Promise<CallWindowLimitList | undefined> {
    let res = CallWindowLimitList.create();
    try {
      res = await this.self.batchGetCallWindowLimit(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Update(req: CallWindowLimit): Promise<CallWindowLimit | undefined> {
    let res = CallWindowLimit.create();
    try {
      res = await this.self.updateCallWindowLimit(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Delete(req: CallWindowLimit): Promise<Empty | undefined> {
    let res = Empty.create();
    try {
      res = await this.self.deleteCallWindowLimit(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // Helper method to load a department's window-limit overrides
  public loadCallWindowLimits = async ({
    filter,
  }: LoadCallWindowLimitsRequest): Promise<CallWindowLimitList> => {
    const req = CallWindowLimit.create();
    req.pageNumber = -1;

    if (filter.callWindowId !== undefined) {
      req.callWindowId = filter.callWindowId;
    }
    if (filter.isActive !== undefined) {
      req.isActive = filter.isActive;
    }

    const result = await this.BatchGet(req);
    return result || CallWindowLimitList.create();
  };
}

export { CallWindowLimitClient, CallWindowLimit, CallWindowLimitList };

export type LoadCallWindowLimitsRequest = {
  filter: CallWindowLimitFilter;
};

export type CallWindowLimitFilter = {
  callWindowId?: number;
  isActive?: boolean;
};
